<template>
	<div>
		<template v-if="audit">
			<v-row>
				<v-col cols="12" sm="6">
					<div class="text-left text-h5 text--secondary pb-2">Expediente personal</div>
					<v-card
						class="backgroundTransparent"
						max-height="700"
						style="overflow-y: auto; "
					>
						<v-card-text>
							<timeLine-expedient
								:expedient="sort(audit.expedient)"
								:format-date="formatDate"
								:paginator="paginator"
							/>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="12" sm="6">
					<div class="text-left text-h5 text--secondary pb-2">Sus actividades</div>
					<v-card
						class="backgroundTransparent"
						max-height="700"
						style="overflow-y: auto; "
					>
						<v-card-text>
							<timelineActivity
								:activities="sort(audit.activities)"
								:format-date="formatDate"
								:paginator="paginator"
							/>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</template>
		<v-overlay absolute v-else-if="loading" :value="loading">
			<v-progress-circular color="primary" indeterminate size="48"></v-progress-circular>
		</v-overlay>
		<empty v-else-if="!loading && !audit" title="Vacío" msj="Sin informacion" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Empty from '@/components/ui/DataEmpty';

export default {
	components: {
		Empty,
		TimeLineExpedient: () => import('@/components/audits/TimelineExpedient'),
		TimelineActivity: () => import('@/components/audits/TimelineActivity'),
	},
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			tab: 0,
		};
	},
	computed: {
		...mapGetters({
			audit: 'Audit/audit',
		}),
	},
	methods: {
		formatDate(date) {
			return moment(date).format('LLL');
		},
		sort(item) {
			return item.sort((a, b) => moment(b.date) - moment(a.date));
		},
		paginator(items, curretPage) {
			const skip = (curretPage - 1) * 10;
			return items.slice(skip).slice(0, 10);
		},
	},
};
</script>

<style lang="scss" scoped>
.v-application ul {
	padding-left: 0 !important;
}
</style>
